/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, October 2020
 * @format
 * @flow
 */

import { all, takeLatest, put } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import API from '../../requests';
import { callAPI } from './callAPI';

interface loginDetailsType {
  latitude: string;
  longitude: string;
  deviceExternalId: string;
  code: string;
}
interface loginType {
  payload: loginDetailsType;
}

export function* login({ payload }: { payload: loginType }): any {
  yield callAPI(payload, ActionTypes.LOGIN, API.login);
}

export function* getStoreJobs({ payload }: { payload: loginType }): any {
  yield callAPI(payload, ActionTypes.GET_STORE_JOBS, API.getStoreJobs);
}

export default function* root(): any {
  yield all([
    takeLatest(ActionTypes.LOGIN_REQUEST, login),
    takeLatest(ActionTypes.GET_STORE_JOBS_REQUEST, getStoreJobs),
  ]);
}
